import { API_AUTH, setTokenGlobal, API_AUTHNEW } from "../common";
import { Cookies } from "react-cookie";
import { getDomain, getUserLogin } from "utils/utils";

var urlNew = getDomain();
const cookies = new Cookies();
var token = cookies.get("userTokenDaiLy");
if (typeof token != "undefined" && token.length > 6) {
  token = token.substring(6);
  setTokenGlobal(token, urlNew);
}
export default {
  // addOrUpdateBanHang: (params) =>
  //   API_AUTH.post("banhang/addOrUpdateBanHang", params),
  getBanHangById: (params) =>
    API_AUTH.get("banhang/getBanHangPrint?OrderID=" + params),
  Autocomplete: (tukhoa) =>
    API_AUTH.get(`khachhang/getKhachHang${tukhoa.params}`, {}),

  getChiTietKhachHangById: (dateCheck, CustomerId, OrderID) => {
    if (typeof OrderID == "undefined") {
      OrderID = 0;
    }
    return API_AUTH.get(
      `khachhang/getKhachHangById?dateCheck=${dateCheck}&CustomerId=${CustomerId}&OrderID=${OrderID}`,
      {}
    );
  },
  AutocompleteSanPham: (tukhoa) =>
    API_AUTH.get(`banhang/SearchCategory${tukhoa.params}`, {}),
  getChiTietSanPhamById: (
    iCategoryID,
    iStore,
    iBranch,
    CustomerId,
    NgayBan
  ) => {
    return API_AUTH.get(
      `banhang/GetChiTietByCategoryID?iCategoryID=${iCategoryID}&iStore=${iStore}&iBranch=${iBranch}&CustomerId=${CustomerId}&NgayBan=${NgayBan}`,
      {}
    );
  },
  GetGiaVaTonKhoByCategoryID: (CategoryID, iStore, NgayBan, isLayHoaDon) => {
    return API_AUTH.get(
      `banhang/GetGiaVaTonKhoByCategoryID?CategoryID=${CategoryID}&iStore=${iStore}&NgayBan=${NgayBan}&isLayHoaDon=${isLayHoaDon}`,
      {}
    );
  },
  GetChiTietDonHangByLoaiPBCNId: (OrderId, LoaiPBCNID) => {
    return API_AUTH.get(
      `banhang/GetChiTietDonHangByLoaiPBCNId?OrderID=${OrderId}&LoaiPBCNID=${LoaiPBCNID}`,
      {}
    );
  },
  AutocompleteMaCuon: (tukhoa) =>
    API_AUTH.get(`banhang/GetListMaCuonByCateID${tukhoa.params}`),

  addOrUpdateBanHang: (params) =>
    API_AUTH.post(
      "banhang/addOrUpdateBanHang?sUserName=" + params.sUserName,
      params
    ),
  list: ({
    fromDate,
    toDate,
    sSearch,
    sUserName,
    sCustomerName,
    iTrangThaiTruKho,
    iTrangThaiThanhToan,
    iBranch,
    sBranch,
    sNVKDUserName,
    lstNhomKH,
    iLoaiDon,
    iLoaiDoiTac,
    iPageIndex,
    iPageSize,
    TinhThanhPhoId,
    QuanhuyenId,
    PhuongxaId,
  }) =>
    API_AUTH.get(
      `banhang/DanhSachDonDatHang?fromDate=${fromDate}&toDate=${toDate}&sSearch=${sSearch}&sUserName=${sUserName}&sCustomerName=${sCustomerName}&iTrangThaiTruKho=${iTrangThaiTruKho}&iTrangThaiThanhToan=${iTrangThaiThanhToan}&iBranch=${iBranch}&sBranch=${sBranch}&sNVKDUserName=${sNVKDUserName}&lstNhomKH=${lstNhomKH}&iLoaiDon=${iLoaiDon}&iLoaiDoiTac=${iLoaiDoiTac}&iPageIndex=${iPageIndex}&iPageSize=${iPageSize}&TinhThanhPhoId=${TinhThanhPhoId}&QuanhuyenId=${QuanhuyenId}&PhuongxaId=${PhuongxaId}`,
      {}
    ),


  // InDanhSachDonDatHang: (
  //   fromDate,
  //   toDate,
  //   sSearch,
  //   sUserName,
  //   sCustomerName,
  //   iTrangThaiTruKho,
  //   iTrangThaiThanhToan,
  //   iBranch,
  //   sBranch,
  //   sNVKDUserName,
  //   lstNhomKH,
  //   iLoaiDon,
  //   iLoaiDoiTac,
  //   iPageIndex,
  //   iPageSize,
  //   TinhThanhPhoId,
  //   QuanhuyenId,
  //   PhuongxaId,
  // ) =>
  //   API_AUTHNEW.get(
  //     `banhang/InDanhSachDonDatHang?fromDate=${fromDate}&toDate=${toDate}&sSearch=${sSearch}&sUserName=${sUserName}&sCustomerName=${sCustomerName}&iTrangThaiTruKho=${iTrangThaiTruKho}&iTrangThaiThanhToan=${iTrangThaiThanhToan}&iBranch=${iBranch}&sBranch=${sBranch}&sNVKDUserName=${sNVKDUserName}&lstNhomKH=${lstNhomKH}&iLoaiDon=${iLoaiDon}&iLoaiDoiTac=${iLoaiDoiTac}&iPageIndex=${iPageIndex}&iPageSize=${iPageSize}&TinhThanhPhoId=${TinhThanhPhoId}&QuanhuyenId=${QuanhuyenId}&PhuongxaId=${PhuongxaId}`,
  //     {}
  //   ),


  chiTietDonHang: (OrderID) => {
    return API_AUTH.get(`banhang/GetDonHangByOrderId?OrderID=${OrderID}`, {});
  },
  chiTietDonHangTaoLSX: (OrderID) => {
    return API_AUTH.get(
      `banhang/GetDonHangTaoLSXByOrderId?OrderID=${OrderID}`,
      {}
    );
  },
  chiTietDonHangTaoLSXQuyTrinh: (OrderID) => {
    return API_AUTH.get(
      `banhang/GetDonHangTaoQuyTrinhByOrderId?OrderID=${OrderID}`,
      {}
    );
  },
  GetChiTietDonHangHienThiByOrderId: (OrderID) => {
    return API_AUTH.get(
      `banhang/GetChiTietDonHangHienThiByOrderId?OrderID=${OrderID}`,
      {}
    );
  },
  GetChiTietDonHangHienThiByOrderCode: (OrderCode) => {
    return API_AUTH.get(
      `banhang/GetChiTietDonHangHienThiByOrderCode?OrderCode=${OrderCode}`,
      {}
    );
  },
  addOrUpdateBanHangChoDuyet: (params) =>
    API_AUTH.post(
      "banhang/saveBanHangChoDuyet?sUserName=" + params.sUserName,
      params
    ),
  getFullRole: (username) => {
    return API_AUTH.get(`users/getAllRoleInUser?username=${username}`, {});
  },
  getListNVKD: (UserName) => {
    return API_AUTH.get(
      `NhanVienKinhDoanh/GetNhanVienKinhDoanhByUserName?UserName=${UserName}`,
      {}
    );
  },
  xoaDonhang: (OrderID, sUserName, Note) => {
    return API_AUTH.post(
      `banhang/XoaDonHang?OrderID=${OrderID}&sUserName=${sUserName}&Note=${Note}`,
      {}
    );
  },
  thanhToanDonHang: (OrderID, SoTien, iLoaiGiaoDich, sUserName, Note) => {
    return API_AUTH.post(
      `banhang/ThanhToanDonHang?OrderID=${OrderID}&SoTien=${SoTien}&iLoaiGiaoDich=${iLoaiGiaoDich}&sUserName=${sUserName}&Note=${Note}`,
      {}
    );
  },
  getChiTietLichSuSua: (OrderID) => {
    return API_AUTH.get(`banhang/LichSuSuaDonHang?OrderID=${OrderID}`, {});
  },
  createLenhSanXuatTuDonBanHang: (OrderID) => {
    return API_AUTH.get(
      `banhang/TaoLenhSanXuatTuDonBanHang?OrderID=${OrderID}`,
      {}
    );
  },
  saveGiaoNhan: (OrderID, isGiaoNhan) => {
    return API_AUTH.post(
      `banhang/SaveGiaoNhan?OrderID=${OrderID}&isGiaoNhan=${isGiaoNhan}&userName=${getUserLogin().UserName
      }`,
      {}
    );
  },
  listInNhanh: (lstOrderID) => {
    return API_AUTH.get(
      `banhang/PrintNhanhDonHang?lstOrderID=${lstOrderID}`,
      {}
    );
  },
  listInNhanhChoXuatKho: (lstOrderID) => {
    return API_AUTH.get(
      `banhang/PrintDonChoXuatKho?lstOrderID=${lstOrderID}`,
      {}
    );
  },
  inPhieuXuatKho: (lstOrderID, iBranch) => {
    return API_AUTH.get(
      `banhang/LoadThongTinExportTruKho?exportId=${lstOrderID}&iBranch=${iBranch}`,
      {}
    );
  },
  listInLenhCat: (lstOrderID) => {
    return API_AUTH.get(
      `banhang/PrintPhieuLenhCat?lstOrderID=${lstOrderID}`,
      {}
    );
  },
  addYeuCauChoDuyet: (OrderID, Note, sUserName) => {
    return API_AUTH.post(
      `banhang/SaveYeuCauChoDuyet?OrderID=${OrderID}&Note=${Note}&sUserName=${sUserName}`,
      {}
    );
  },
  PrintChiTietDonHang: (OrderID, MauIn, ConfigCkCongThuc) => {
    return API_AUTH.post(
      `banhang/PrintChiTietDonHang?OrderID=${OrderID}&MauIn=${MauIn}&ConfigCkCongThuc=${ConfigCkCongThuc}`,
      {}
    );
  },
  getDanhSachTinhThanh: (TinhThanhId) => {
    return API_AUTH.get(`banhang/GetTinhThanh?TinhThanhId=${TinhThanhId}`, {});
  },
  checkCanhBaoDonHang: (params) => {
    return API_AUTH.post(`banhang/kiemTraTrungDon`, params);
  },

  getListNVKDNew: (tenNhanVien, iBranch, pageIndex, pageSize) => {
    return API_AUTH.get(
      `nhanvienkd/DanhSachNhanVienKinhDoanh?tenNhanVien=${tenNhanVien}&iBranch=${iBranch}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    );
  },

  postKiemTraThucTon: (params) => {
    console.log("paramsparamsparams", params);
    return API_AUTH.post(
      `banhang/kiemTraThucTon`, params);
  },

  getOptionForOrder: (optionId, categoryId, customerId, branchId) => {
    return API_AUTH.get(
      `banhang/GetOptionForOrder?optionId=${optionId}&categoryId=${categoryId}&customerId=${customerId}&branchId=${branchId}`,
      {}
    );
  },

};
